import type React from "react";
import { forwardRef } from "react";
import styles from "./backDrop.module.scss";
import { CSSTransition } from "react-transition-group";

import clsx from "clsx";

export interface BackDropProps {
  open: boolean;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  children?: JSX.Element | JSX.Element[];
}

const BackDrop = forwardRef<HTMLDivElement, BackDropProps>(
  (props: BackDropProps, ref) => {
    const { open, className, children, onClick } = props;
    return (
      <CSSTransition
        in={open}
        timeout={{ enter: 0, exit: 300 }}
        classNames={{
          enterDone: styles["back-drop--enter-done"],
          exit: styles["back-drop--exit"],
        }}
        unmountOnExit
      >
        <div
          ref={ref}
          className={clsx(styles["back-drop"], className)}
          onClick={onClick}
        >
          {children}
        </div>
      </CSSTransition>
    );
  },
);

export default BackDrop;
